/**
 * Video Slider
 * @requires https://swiperjs.com/
 */

export default (() => {
  /* eslint-disable no-undef, no-unused-vars  */
  const videoSlider = new Swiper('#video-slider', {
    loop: true,
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    speed: 500,
    watchSlidesProgress: true,

    navigation: {
      prevEl: '#prevVideo',
      nextEl: '#nextVideo',
    },

    keyboard: {
      enabled: true,
      onlyInViewport: true,
      pageUpDown: true,
    },

    mousewheel: {
      forceToAxis: true,
      thresholdDelta: 15,
    },

    breakpoints: {
      0: {
        liftPx: 48,
        spaceBetween: 8,
      },
      500: {
        liftPx: 52,
        spaceBetween: 8,
      },
      768: {
        liftPx: 60,
        spaceBetween: 12,
      },
      992: {
        liftPx: 64,
        spaceBetween: 12,
      },
      1200: {
        liftPx: 68,
        spaceBetween: 12,
      },
    },

    on: {
      init() {
        playVideo(this, this.activeIndex)

        requestAnimationFrame(() => {
          this.updateSlidesProgress()
          this.emit('setTranslate', this)
        })
      },

      setTranslate(swiper) {
        const liftPx = swiper.params.liftPx ?? 20

        swiper.slides.forEach((slide) => {
          const inner = slide.querySelector('.swiper-slide-inner')
          if (!inner) return

          const p = slide.progress ?? 0
          const lift = liftPx * (1 - Math.min(Math.abs(p), 1))

          inner.style.transform = `translate3d(0, ${-lift}px, 0)`
        })
      },

      setTransition(swiper, duration) {
        swiper.slides.forEach((slide) => {
          const inner = slide.querySelector('.swiper-slide-inner')
          if (inner) inner.style.transition = `${duration}ms`
        })
      },

      slideChangeTransitionEnd() {
        rewindVideo(this, this.previousIndex)
        playVideo(this, this.activeIndex)
      },
    },
  })

  const labelsSlider = new Swiper('#video-slider-labels', {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    allowTouchMove: false,
    loop: true,
  })

  function playVideo(slider, idx) {
    const video = slider.slides[idx].querySelector('video')
    if (!video) return
    video.play().catch(() => {
      video.play()
    })
  }

  function rewindVideo(slider, idx) {
    const video = slider.slides[idx].querySelector('video')
    if (!video) return
    video.pause()
  }

  // Sync sliders
  videoSlider.on('slideChange', function () {
    labelsSlider.slideToLoop(this.realIndex)
  })

  /* eslint-enable no-undef, no-unused-vars  */
})()
